<div id="anc-support" class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
  <div class="p-heading-area01">
    <div class="p-heading-area01__title">
      <h2 class="c-heading-2" role="heading" aria-level="2">
        <asw-text-with-tooltip
          [tooltipText]="'label.support' | staticMsg"
          [tooltipContent]="'tooltip.supportinformation1' | staticMsg"
        ></asw-text-with-tooltip>
      </h2>
    </div>
    <div class="p-heading-area01__sub-function">
      <button
        class="c-btn-quaternary c-btn-quaternary--xs"
        id="support-detail-btn"
        (click)="openConsiderationSupportDetailsModal()"
      >
        <span class="c-btn-quaternary__text" [innerHTML]="'label.detailButton' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div class="p-mybooking-services-support">
    <dl class="c-float-list03">
      <ng-container *ngFor="let traveler of supportPassengerInforList">
        <div class="c-float-list03__item">
          <dt class="c-float-list03__title">
            <span class="c-float-list03__title--em c-float-list03__contents--fs16">{{
              getTravelerName(traveler)
            }}</span>
            <br />
            <span class="c-float-list03__title--gray60" *ngIf="isAccompanyingTraveler(traveler)">
              {{ getAccompanyingTraveler(traveler) }}</span
            >
          </dt>
          <dd class="c-float-list03__contents c-float-list03__contents--fs16">
            <span
              class="c-float-list03__text--normal"
              [innerHTML]="getConsiderationSupportInforRegistrationStatus(traveler?.id)"
            ></span>
          </dd>
        </div>
      </ng-container>
    </dl>
  </div>
</div>
